import { render, staticRenderFns } from "./DataSourceSelect.vue?vue&type=template&id=1567cc70&scoped=true&"
import script from "./DataSourceSelect.vue?vue&type=script&lang=js&"
export * from "./DataSourceSelect.vue?vue&type=script&lang=js&"
import style0 from "./DataSourceSelect.vue?vue&type=style&index=0&id=1567cc70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1567cc70",
  null
  
)

export default component.exports